import { styled, DialogActions as DialogActions$1 } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const DialogActions = styled(
  DialogActions$1,
  shouldNotForwardProps(["noBorder", "noStack"])
)(({
  noStack,
  noBorder,
  theme: t
}) => ({
  backgroundColor: t.palette.dialog.primary.content,
  justifyContent: "space-between",
  gap: 24,
  margin: 0,
  borderTop: noBorder ? void 0 : `1px solid ${t.palette.border.base.elevation1}`,
  button: {
    margin: "0!important"
  },
  // paddings
  padding: t.sizes.common.sm,
  [t.breakpoints.up("sm")]: {
    padding: t.sizes.common.md
  },
  //
  [t.breakpoints.only("xs")]: {
    ...!noStack && {
      gap: t.sizes.common.xs,
      flexDirection: "column-reverse",
      button: {
        width: "100%"
      }
    }
  }
}));
DialogActions.displayName = "DialogActions";
export {
  DialogActions
};
//# sourceMappingURL=DialogActions.js.map
